import { useEngineStore } from '../state/engineStore';

type TopbarProps = {
  title: string;
  subtitle?: string;
};

export function Topbar({ title, subtitle }: TopbarProps) {
  const { readings, clearReadings, resetPeaks } = useEngineStore();
  const hasAnyReading = readings.cylinders.some(
    (c) => c.egt !== undefined || c.cht !== undefined,
  );
  const hasAnyPeak = readings.cylinders.some((c) => c.peakEgt !== undefined);

  return (
    <header className="topbar">
      <div>
        <div className="topbar-title">{title}</div>
        {subtitle && <div className="topbar-sub">{subtitle}</div>}
      </div>
      <div className="row" style={{ gap: 8 }}>
        {hasAnyPeak && (
          <button
            type="button"
            className="btn sm ghost"
            onClick={resetPeaks}
            title="Forget captured peak EGTs — start a fresh leaning cycle"
          >
            Reset peaks
          </button>
        )}
        {hasAnyReading && (
          <button
            type="button"
            className="btn sm ghost"
            onClick={clearReadings}
            title="Clear all entered values"
          >
            Clear readings
          </button>
        )}
      </div>
    </header>
  );
}
